@if (partRows !== null && displayedColumns !== undefined) {
    <osc-base-table
        [items]="partRows"
        [columns]="displayedColumns"
        [hideMarkedBar]="true"
        [showCheckboxColumn]="showCheckboxColumn"
        [checked]="checkedRows"
        [compareOnlyRef]="false"
        [compareFunction]="selectedRowsCompareFunction"
        (rowSelect)="onRowSelect($event)"
    >
        <ng-container cdkColumnDef="name">
            <th cdk-header-cell *cdkHeaderCellDef>
                <osc-text-table-header
                    [name]="'SPARE_PARTS.TABLE.PART_NAME' | translate"
                ></osc-text-table-header>
            </th>
            <td cdk-cell *cdkCellDef="let row">{{ row.rowData.name }}</td>
        </ng-container>
        <ng-container cdkColumnDef="materialNumber">
            <th cdk-header-cell *cdkHeaderCellDef>
                <osc-text-table-header
                    [name]="'SPARE_PARTS.TABLE.MAT_NO' | translate"
                ></osc-text-table-header>
            </th>
            <td cdk-cell *cdkCellDef="let row">{{ row.rowData.id }}</td>
        </ng-container>
        <ng-container cdkColumnDef="wear">
            <th cdk-header-cell *cdkHeaderCellDef>
                <osc-text-table-header [name]="'SPARE_PARTS.TABLE.WEAR' | translate"></osc-text-table-header>
            </th>
            <td cdk-cell *cdkCellDef="let row">
                @if (row.rowData.wear) {
                    <sew-icon icon="gear-drop" class="wear" [oscTooltip]="wearTooltip"></sew-icon>
                }
            </td>
        </ng-container>
        <ng-container cdkColumnDef="amount">
            <th cdk-header-cell *cdkHeaderCellDef>
                <osc-text-table-header
                    [name]="'SPARE_PARTS.TABLE.AMOUNT' | translate"
                    [ellipsis]="true"
                    class="header-amount"
                ></osc-text-table-header>
            </th>
            <td cdk-cell *cdkCellDef="let row" class="amount-row">
                <ng-template #tooltipResetToInstalledQuantity>
                    <osc-default-tooltip>
                        {{ 'TOOLTIP.RESET_TO_INSTALLED_QUANTITY' | translate }}
                    </osc-default-tooltip>
                </ng-template>
                @if (partAmounts[row.rowData.id] !== (row.rowData.installedQuantity ?? 1)) {
                    <sew-button
                        class="amount-button"
                        icon="restore"
                        hierarchy="tertiary"
                        size="xs"
                        [oscTooltip]="tooltipResetToInstalledQuantity"
                        show-icon-only
                    >
                        <button
                            (click)="partAmounts[row.rowData.id] = row.rowData.installedQuantity ?? 1"
                        ></button>
                    </sew-button>
                }
                <sew-table-input>
                    <input
                        type="number"
                        min="1"
                        class="amount-input"
                        [(ngModel)]="partAmounts[row.rowData.id]"
                        [disabled]="row.isDisabled"
                        oscNumbersOnly
                    />
                </sew-table-input>
            </td>
        </ng-container>
        <ng-container cdkColumnDef="availability">
            <th cdk-header-cell *cdkHeaderCellDef>
                <osc-text-table-header
                    [name]="'SPARE_PARTS.TABLE.AVAILABILITY' | translate"
                ></osc-text-table-header>
            </th>
            <td cdk-cell *cdkCellDef="let row">
                @switch (userLoggedIn) {
                    @case (true) {
                        <ng-container *oscNgUse="row.rowData.availabilityCode as availabilityCode">
                            @switch (true) {
                                @case (availabilityCode === '00' || availabilityCode === '04') {
                                    @if (row.rowData.availability === undefined) {
                                        <sew-loader-mini></sew-loader-mini>
                                    } @else {
                                        <ecs-availability-cell
                                            [availability]="row.rowData.availability"
                                        ></ecs-availability-cell>
                                    }
                                }
                                @default {
                                    {{ row.rowData.availabilityText }}
                                }
                            }
                        </ng-container>
                    }
                    @case (false) {
                        <sew-link icon="lock-locked">
                            <a [href]="loginUrl">{{ 'LOGIN' | translate }}</a>
                        </sew-link>
                    }
                }
            </td>
        </ng-container>
        <ng-container cdkColumnDef="expandableRow"> </ng-container>
        <ng-container cdkColumnDef="fullRowContent"> </ng-container>
        <ng-container cdkColumnDef="groupHeaderIcon"> </ng-container>
        <ng-container cdkColumnDef="groupHeaderName"> </ng-container>
    </osc-base-table>
} @else {
    <ecs-part-table-skeleton
        [showGroupHeader]="showPartGroupHeaderAsSkeleton"
        [rowCount]="4"
    ></ecs-part-table-skeleton>
}

<ng-template #wearTooltip>
    <osc-default-tooltip>
        {{ 'SPARE_PARTS.TABLE.TOOLTIP.WEAR' | translate }}
    </osc-default-tooltip>
</ng-template>
